import axios from "axios";
import Vue from "vue";
import Cookies from "js-cookie";

/**
 * @category Headers ::
 * ::::::::::::::::::::::::::::::::::::::::::::::::::::
 */
var config = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};

Vue.prototype.$http = axios;

// Interceptor: 401 fuera de /login → limpia sesión y manda a /login
// (evita skeleton infinito tras logout o token expirado).
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err && err.response && err.response.status;
    if (status === 401 && window.location.pathname !== "/login") {
      try {
        Cookies.remove("session_id");
        localStorage.removeItem("infoUser");
        localStorage.removeItem("tenant");
        delete axios.defaults.headers.common["Authorization"];
      } catch (_) { /* ignore */ }
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

/**
 * @category Route ::
 * ::::::::::::::::::::::::::::::::::::::::::::::::::::
 */
// Backend HUB central — admin-data-api (Laravel 10)
// Producción: hub.<dominio>.com
// Desarrollo: http://127.0.0.1:8000
const isProd = process.env.NODE_ENV === "production";
const baseUri = isProd
  ? (process.env.VUE_APP_API_URL || "https://adnexis.com.mx/api/")
  : "https://adnexis.com.mx/api/";

// Super admin: marca activa elegida en el switcher → se manda como ?marca= en peticiones DC.
function activeDcMarca() {
  try {
    const info = JSON.parse(localStorage.getItem("infoUser") || "{}");
    if (! info.is_super_admin) return null;
    const m = localStorage.getItem("dc_active_marca");
    return (! m || m === "__all__") ? null : m;   // "__all__" = todas las marcas → sin forzar tenant
  } catch (e) { return null; }
}
function withDcMarca(endpoint) {
  const marca = activeDcMarca();
  if (! marca || endpoint.indexOf("director-comercial") === -1) return endpoint;
  return endpoint + (endpoint.indexOf("?") === -1 ? "?" : "&") + "marca=" + encodeURIComponent(marca);
}

var api = {
  baseUri: baseUri,

  baseUriFiles: isProd
    ? (process.env.VUE_APP_STORAGE_URL || "https://adnexis.com.mx/storage/")
    : "https://adnexis.com.mx/storage/",

  get: function(endpoint, params = null, show_lodader = false, skip_dc_marca = false) {
    var url = new URL(baseUri + (skip_dc_marca ? endpoint : withDcMarca(endpoint)));

    if (params) {
      Object.keys(params).forEach(function(key) {
        url.searchParams.append(key, params[key]);
      });
    }

    show_lodader ? api.loader(true) : null;

    return new Promise((resolve) => {
      axios.get(url.href, config).then((response) => {
        show_lodader ? api.loader(false) : null;
        resolve(response);
      });
    });
  },
  post: function(endpoint, data, show_lodader = false, skip_dc_marca = false) {
    show_lodader ? api.loader(true) : null;

    return new Promise((resolve, reject) => {
      axios.post(baseUri + (skip_dc_marca ? endpoint : withDcMarca(endpoint)), data, config).then(
        (response) => {
          show_lodader ? api.loader(false) : null;
          resolve(response);
        },
        (error) => {
          show_lodader ? api.loader(false) : null;
          reject(error);
        }
      );
    });
  },
  put: function(endpoint, data) {
    return axios.put(baseUri + withDcMarca(endpoint), data, config);
  },
  patch: function(endpoint, data) {
    return axios.patch(baseUri + withDcMarca(endpoint), data, config);
  },
  delete: function(endpoint) {
    return axios.delete(baseUri + withDcMarca(endpoint), config);
  },
  authorization: function(status, token) {
    if (status) {
      return (axios.defaults.headers.common["Authorization"] =
        "Bearer " + token);
    } else {
      return delete axios.defaults.headers.common["Authorization"];
    }
  },
};

export default api;
